<div class="container">
  <div class="main no-stepper">
    <form [formGroup]="newSiteForm" fcFormUnloadWarning>
      <div class="form-step-container">
        <div class="form-step-title">Create your account</div>
        <div class="input-label">As a first step, please set up an account with LandYield. This will let us communicate
          with
          you as you explore the possibility of enrolling your land in our carbon program.
        </div>
        <div class="input-label">Contact Information</div>
        <div class="w-100-1">
          <div class="form-inner-fields">
            <mat-form-field class="w-50-2">
              <mat-label>First Name</mat-label>
              <input formControlName="firstName" id="firstName" matInput required type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Last Name</mat-label>
              <input formControlName="lastName" id="lastName" matInput required type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Email</mat-label>
              <input formControlName="email" id="email" matInput required type="text">
              <mat-error>{{ emailError }}</mat-error>
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Phone</mat-label>
              <input formControlName="phone" id="phone" matInput required type="text" (blur)="formatPhone($event)" />
              @if (phoneNumberError) {
                <mat-error>
                  This phone number is invalid.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="input-label">Property Information</div>

        <mat-form-field class="full-width">
          <mat-label>Forested Acreage</mat-label>
          <input formControlName="acres" id="acres" matInput required type="number" />
        </mat-form-field>


        <mat-form-field class="full-width">
          <mat-label>State & County</mat-label>
          <input
            matInput
            type="text"
            placeholder="Provide state and county name"
            aria-label="county"
            formControlName="county" />
        </mat-form-field>
        <input formControlName="hiddenCheck" class="hidden-check" autocomplete="current-password" />

        <div class="step-button-container">
          <button
            (click)="checkAcreageAndProceed()"
            [disabled]="!newSiteForm.valid"
            color="primary"
            data-cy="next-button"
            mat-raised-button
            type="button">
            Create Account
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
